import { useState } from 'react';
import type { FormEvent } from 'react';
import { api, ApiError } from '../lib/api';
import type { Me } from '../lib/api';
import { titleCase } from '../lib/format';
import { Panel } from './ui';

/** Password change for the signed-in account. Shared by the Admin page and the client shell. */
export function AccountPanel({ me }: { me: Me }) {
  const [pw, setPw] = useState({ current: '', next: '', confirm: '' });
  const [msg, setMsg] = useState<string | null>(null);

  async function changePassword(e: FormEvent) {
    e.preventDefault();
    setMsg(null);
    if (pw.next !== pw.confirm) { setMsg('The new passwords do not match.'); return; }
    try { await api('/api/auth/password', { method: 'POST', json: { current: pw.current, next: pw.next } }); setPw({ current: '', next: '', confirm: '' }); setMsg('Password changed.'); }
    catch (ex) { setMsg(ex instanceof ApiError && ex.status === 401 ? 'Current password is wrong.' : (ex as Error).message); }
  }

  const who = me.role === 'client' && me.client ? `${me.client.name} · client access` : `${titleCase(me.role)} · ${me.tenant.name}`;
  return (
    <Panel title="Your account">
      <form onSubmit={changePassword}>
        <div className="form-grid">
          <div className="field span-2"><label>Signed in as</label><div>{me.user.email} · {who}</div></div>
          <div className="field"><label htmlFor="pw-cur">Current password</label><input id="pw-cur" className="input" type="password" autoComplete="current-password" required value={pw.current} onChange={(e) => setPw({ ...pw, current: e.target.value })} /></div>
          <div className="field"><label htmlFor="pw-next">New password (12+ characters)</label><input id="pw-next" className="input" type="password" autoComplete="new-password" required minLength={12} value={pw.next} onChange={(e) => setPw({ ...pw, next: e.target.value })} /></div>
          <div className="field"><label htmlFor="pw-conf">Confirm new password</label><input id="pw-conf" className="input" type="password" autoComplete="new-password" required minLength={12} value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} /></div>
        </div>
        {msg && <div className={msg === 'Password changed.' ? 'muted' : 'error-text'} style={{ marginTop: 8 }}>{msg}</div>}
        <div className="form-actions"><button className="primary-btn" type="submit">Change password</button></div>
      </form>
    </Panel>
  );
}
